module.exports = __webpack_public_path__ + "img/icon_pause.c937a44c.svg";